// Flow types automatically removed

import classNames from 'classnames';
import { FormattedMessage } from 'dibs-react-intl';
import PlayButton from 'dibs-icons/exports/legacy/PlayButton.ts';
import ViewImage from 'dibs-icons/exports/legacy/ZoomIn.ts';
import DeleteIcon from 'dibs-icons/exports/legacy/TrashCan.ts';
import styles from './styles/ImageUploaderImageRenderer.scss';
import { DeleteConfirmation } from './DeleteConfirmation.tsx';
import { useState } from 'react';

const ImageOrPlayButton = props => {
    const { imageClasses, mediaLocation, mediaType } = props;
    return mediaType === 'photo' ? (
        <img data-tn="stored-image" className={imageClasses} src={mediaLocation} alt="" />
    ) : (
        <PlayButton className={imageClasses} />
    );
};

const ImageUploaderImageRenderer = props => {
    const {
        classes,
        isLocked,
        isPrimary,
        mediaLocation,
        mediaType,
        showDeleteConfirmation,
        onConfirmDelete,
        onHideDeleteConfirmation,
        renderNoMediaPlaceholder,
        segmentedView,
        size,
        openPreviewModal,
        showActionIcons,
        onDelete,
    } = props;
    const [showHover, setShowHover] = useState(false);
    const hoverCopy = showHover ? (
        <FormattedMessage
            id="dibs-media-uploader.ImageUploaderImageRenderer.dragToRearrange"
            defaultMessage="Drag to rearrange"
        />
    ) : null;
    const primaryHoverCopy =
        isPrimary && showHover ? (
            <FormattedMessage
                id="dibs-media-uploader.ImageUploaderImageRenderer.dragDifferentImageHereToChange"
                defaultMessage="Drag a different image here to change"
            />
        ) : null;

    if (!mediaLocation) {
        return renderNoMediaPlaceholder && renderNoMediaPlaceholder();
    } else {
        const { image: imageClass } = classes;
        const imageClasses = classNames(styles.image, imageClass);
        const primaryCopy = segmentedView ? (
            <FormattedMessage
                id="dibs-media-uploader.ImageUploaderImageRenderer.primaryImage"
                defaultMessage="PRIMARY IMAGE"
            />
        ) : (
            <FormattedMessage
                id="dibs-media-uploader.ImageUploaderImageRenderer.primary"
                defaultMessage="PRIMARY"
            />
        );
        return (
            <div className={imageClasses}>
                {showDeleteConfirmation ? (
                    <DeleteConfirmation
                        imageClasses={imageClasses}
                        onConfirmDelete={onConfirmDelete}
                        onHideDeleteConfirmation={onHideDeleteConfirmation}
                    />
                ) : (
                    <ImageOrPlayButton
                        imageClasses={imageClasses}
                        mediaLocation={mediaLocation}
                        mediaType={mediaType}
                    />
                )}
                {isPrimary && (
                    <div
                        className={classNames({
                            [styles.primaryLabel]: true,
                            [styles.primaryLabelSmall]: size === 'small',
                            [styles.primaryLabelSegmented]: segmentedView,
                        })}
                    >
                        {primaryCopy}
                    </div>
                )}
                {isPrimary && segmentedView && (
                    <span
                        className={classNames({
                            [styles.primaryHover]: !isLocked,
                        })}
                        onMouseEnter={() => {
                            if (!isLocked) {
                                setShowHover(true);
                            }
                        }}
                        onMouseLeave={() => {
                            setShowHover(false);
                        }}
                    >
                        {primaryHoverCopy}
                    </span>
                )}
                {!isPrimary && segmentedView && (
                    <span
                        className={classNames({
                            [styles.hover]: !isLocked,
                        })}
                        onMouseEnter={() => {
                            if (!isLocked) {
                                setShowHover(true);
                            }
                        }}
                        onMouseLeave={() => {
                            setShowHover(false);
                        }}
                    >
                        {showActionIcons && (
                            <div
                                className={classNames(styles.actionIcons, {
                                    [styles.showHover]: showHover,
                                })}
                            >
                                <span
                                    onClick={onDelete}
                                    className={styles.imageCta}
                                    data-tn="delete-image-button"
                                >
                                    <DeleteIcon className={styles.imageCtaIcon} />
                                </span>
                                <span
                                    onClick={openPreviewModal}
                                    className={styles.imageCta}
                                    data-tn="view-image-button"
                                >
                                    <ViewImage className={styles.imageCtaIcon} />
                                </span>
                            </div>
                        )}
                        <span className={styles.hoverCopy}>{hoverCopy}</span>
                    </span>
                )}
            </div>
        );
    }
};

export { ImageUploaderImageRenderer };
